module.exports = __webpack_public_path__ + "static/img/weixin-icon.04ada730.png";